import React from 'react';
import { connect } from 'react-redux';
import { numberFormat } from '../Extras';
import { Link } from 'react-router-dom';
import { addItemshoppingCartAction } from '../../redux/actions';
import { FaAngleRight } from "react-icons/fa";
import './../Extras/Product.css';
import { Badge } from '@material-ui/core';
import { Fragment } from 'react';

const cardStyle = (stock, toggleEspecification) => {
  if(toggleEspecification === false || toggleEspecification === ""){
    toggleEspecification = false
  }
  else{
      toggleEspecification = true
  }

	return(
		{
		border:'0px solid #E7E7E7',
    paddingBottom: '15px',  
    paddingTop: '10px',
		borderRadius: '5px',
		boxShadow: '2px 3px 5px #E7E7E7',
		marginBottom: '25px',
		backgroundColor: stock === true && toggleEspecification === false ? 'lightGray' : 'white',
	})
}

const nameStyle = {
	fontWeight: 'bold',
	color: '#474747',
}

const priceStyle = () => ({
	fontWeight: 500,
	fontSize: 18
})

class ProductComponent extends React.Component {
  
  displayBadge = (information) => {
    let {price, price2, tag, subCategories, stock, toggleEspecification} = information.data_

    
    let percentage = false
    if(price2 !== undefined && price !== price2 && price2 !== ''){
      percentage = 100 - Math.round(price2 / price * 100)
    }
    
    if(toggleEspecification === false || toggleEspecification === ""){
      toggleEspecification = false
    }
    else{
        toggleEspecification = true
    }

    return(
      <Fragment>
          <div  className="row justify-content-end align-items-center" style={{paddingBottom: '100px', width: '80%', position: 'absolute'}}>
            <div className="mr-4">
              {tag !== '' && tag !== undefined  ? 
                  <Badge 
                    badgeContent={tag} 
                    color="secondary"
                    overlap={'rectangle'}
                  />
                : ''
              }
            </div>
            
            {toggleEspecification === false && stock === false?
              
              <Fragment>
                {information.data_.price !== information.data_.price2 && information.data_.price2 !== undefined && information.data_.price2 !== '' ?
                  <div className="pl-4">
                    <Badge badgeContent={percentage + '%'} color="primary"/>
                  </div> : 
                ''}
              </Fragment> : ''
            }
            
          </div> 
      </Fragment>
    ) 
  }

  displayPrice = (information) => {
    let {price, price2, stock, subCategories,toggleEspecification} = information.data_
    
    if(toggleEspecification === false || toggleEspecification === ""){
        toggleEspecification = false
      }
    else{
        toggleEspecification = true
    }

    if(subCategories === undefined){
      subCategories = []
    }
    
    console.log("jaajaj", toggleEspecification, subCategories)
    //ELIGO EL PRIMEROP D LA SUBLISTA
    if(subCategories.length !== 0 && toggleEspecification === true ){
      price = subCategories[0].price
    }

    return(
      <Fragment>
        <div className="row" style={priceStyle(this.props.shopColor)}>
          {stock === true && toggleEspecification === false  ?  'AGOTADO'  : 
            price !== price2 && price2 !== undefined && price2 !== '' && toggleEspecification === false ? 
              <Fragment>
                <div className="row col-12 col-md-12">
                  ${numberFormat(price2)}
                </div>
                <div className="row col-12 col-md-12 ml-1">
                  <del style={{fontSize: 12}}> ${numberFormat(price)} </del>
                </div>
              </Fragment>
              :
              `$ ${numberFormat(price)}` 
          }
        </div>
      </Fragment>
    )
  }

  displayName = (information) => (
    <Fragment>
       <div className="row"
          style={nameStyle}
        >
          {information.data_.name}
        </div>	
    </Fragment>
  )

	render() {
    const { information } = this.props;
  	let url;

		if (information.data_.images[0] !== undefined && information.data_.images[0].lenght !== 0) {
			const array_ = information.data_.images[0].url.split('?alt');
			url = `${array_[0]}_300x300?alt${array_[1]}`;
		} else {
			url = '';
		}

    information.data_.category = this.props.category


    return (
			<div 
			  style={cardStyle(information.data_.stock, information.data_.toggleEspecification)}
			>	
        <Link style={{color: 'black'}} to={{ 
          pathname: `/${this.props.userName}/products/${this.props.category}/:${information.name}`,
          state: {information, category: this.props.category} 
          }}
        >		

     
          <div className="row justify-content-center align-items-center ml-2 mr-3">
            {this.displayBadge(information)}
            <div className="col-4">
            {url === '' ? 
              <img 
                src={require('../../images/simple2.png')}
                alt="SimpleQr"
                className="smallImage"
              /> : 
                  <img src={url} alt="SimpleQr" className="smallImage" />
            }
            </div>
            <div className="col-5 ml-3">
              {this.displayName(information)}
              {this.displayPrice(information)}
            </div>
            <div className="col-2">
              <FaAngleRight 
                size={24}
                color="#747e90"
                style={{backgroundColor:'#e3e5e8', borderRadius:50, padding:4, paddingLeft:6}}
              />
            </div>
          </div>
        </Link>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	userName: state.userName,
	category: state.category,
});

const mapDispatchToProps = (dispatch) => ({
	addItemShoppingCart(product, quantity, category) {
		dispatch(addItemshoppingCartAction(product, quantity, category));
	}
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductComponent);
